module.exports = __webpack_public_path__ + "media/assets/images/snow_sometime_will_rain-3280e3826ea5b1633c25ab086d2635b9.png";